import React, { useEffect, useState } from 'react';
import { Loader } from '../../components/Loader';
import { EVO } from '../../EVO';
import { urls } from '../../urls';
import { withRouter } from 'react-router-dom';
import './Confirm.css';

const Confirm = props => {
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState({});

    useEffect(() => {
        const id = EVO.getParamsId(props);
        EVO.fetch(urls.api.clients.order(id)).then(r => {
            setOrder(r);
            setLoading(false);
        }).catch(e => {
            EVO.error('Error retrieving order details');
            setLoading(false);
        });
    }, []);

    const Square = ({ children, ...props }) => {
        return <td className="conf-border" {...props}>{children}</td>
    };

    const SquareWidth = ({ children, ...props }) => {
        return <td className="conf-border conf-width" {...props}>{children}</td>
    };

    const date = d => EVO.format(d, 'do MMM yyyy');

    const InvDet = ({ header, value }) => <div className="conf-inv-det"><div className="conf-inv-det-header">{header}:</div><div className="conf-inv-det-value">{value}</div></div>;

    return (
        <Loader loading={loading}>
            {EVO.any(order.items) && <div id="confirm-wrapper">
                <div>
                    <h3>TAX INVOICE</h3>
                    <div id="conf-header">
                        <div>
                            <div>{order.ownerName}</div>
                            <div>{order.business}</div>
                            <div>{order.emailAddress}</div>
                        </div>
                        <div>
                            <InvDet header="Invoice Date" value={date(order.dateAdded)} />
                            <InvDet header="Order Number" value={order.id.substring(0, 8)} />
                            <InvDet header="Order Date" value={date(order.dateAdded)} />
                            <InvDet header="Payment Method" value={'Credit Card (Stripe)'} />
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr><th>Product</th><th className="conf-width">Quantity</th><th className="conf-width">Price</th></tr>
                        </thead>
                        <tbody>
                            {order.items.map(i => <tr key={i.id}>
                                <Square>{i.name}</Square>
                                <SquareWidth>{i.quantity}</SquareWidth>
                                <SquareWidth>${i.price.toFixed(2)}</SquareWidth>
                            </tr>)}
                            <tr>
                                <td></td>
                                <SquareWidth></SquareWidth>
                                <SquareWidth></SquareWidth>
                            </tr>
                            <tr>
                                <td></td>
                                <SquareWidth>Subtotal</SquareWidth>
                                <SquareWidth>${order.total.toFixed(2)}</SquareWidth>
                            </tr>
                            <tr>
                                <td></td>
                                <SquareWidth>GST</SquareWidth>
                                <SquareWidth>${(order.totalIncGst - order.total).toFixed(2)}</SquareWidth>
                            </tr>
                            <tr>
                                <td></td>
                                <SquareWidth>Total</SquareWidth>
                                <SquareWidth>${order.totalIncGst.toFixed(2)}</SquareWidth>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="conf-footer">
                    <div>Nomadigital Pty Ltd trading as Peptalkr</div>
                    <div>ABN 29 650 216 434</div>
                </div>
            </div>}
        </Loader>
    );
}

export default withRouter(Confirm);


// WEBPACK FOOTER //
// ./src/pages/Store/Confirm.js